import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule)
  },
 
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  {
    path: 'search-result',
    loadChildren: () => import('./pages/search/search-result/search-result.module').then( m => m.SearchResultPageModule)
  },
  {
    path: 'search-detail',
    loadChildren: () => import('./pages/search/search-detail/search-detail.module').then( m => m.SearchDetailPageModule)
  },
  {
    path: 'about',
    loadChildren: () => import('./pages/about/about/About.module').then( m => m.AboutPageModule)
  },
  {
    path: 'search-img',
    loadChildren: () => import('./pages/search/search-img/search-img.module').then( m => m.SearchImgPageModule)
  },
  {
    path: 'quiz',
    loadChildren: () => import('./pages/quiz/quiz-start/Quiz.module').then( m => m.QuizPageModule)
  },
  {
    path: 'quizfinish',
    loadChildren: () => import('./pages/quiz/quiz-finish/Quizfinish.module').then( m => m.QuizfinishPageModule)
  },
  {
    path: 'learningrecordlist',
    loadChildren: () => import('./pages/learning-record/learning-record-list/learning-record-list.module').then( m => m.LearningRecordListPageModule)
  },
  {
    path: 'bind',
    loadChildren: () => import('./pages/bind/bind.module').then( m => m.BindPageModule)
  },
  {
    path: 'ios-pwa',
    loadChildren: () => import('./pages/ios-pwa/ios-pwa.module').then( m => m.IosPwaPageModule)
  },
  ,
  {
    path: 'search-camera',
    loadChildren: () => import('./pages/search/search-camera/search-camera.module').then( m => m.SearchCameraPageModule)
  },
  {
    path: 'firefox-pwa',
    loadChildren: () => import('./pages/firefox-pwa/firefox-pwa.module').then( m => m.FirefoxPwaPageModule)
  },
  {
    path: 'instruction',
    loadChildren: () => import('./pages/instruction/Instructionmodule').then( m => m.InstructionPageModule)
  },  {
    path: 'samsung-pwa',
    loadChildren: () => import('./pages/samsung-pwa/samsung-pwa-routing.module').then( m => m.SamsungPwaPageRoutingModule)
  },
  { path: '**', redirectTo: '/home', pathMatch: 'full' },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule]
})

export class AppRoutingModule { }
